// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vpn90","content":"styles_content__1X3P8"};